import React, { createContext, useState } from "react";

import { Typography } from "@material-ui/core";

import HospitalDropdownMenu from "../RodaHomepage/components/HospitalDropdownMenu";
import StatisticsTable from "../RodaHomepage/components/StatisticsTable";
import LightPurpleContainer from "../../components/LightPurpleContainer";
import Container from "../../components/Container";
import HospitalInfoPanel from "../../components/HospitalInfoPanel";
import { PublicHospitalContextType } from "../RodaHomepage/types";
import NoData from "../../components/NoData";

export const PublicHospitalsContext = createContext<PublicHospitalContextType>({
  currentPublicHospital: 0,
  setCurrentPublicHospital: () => {},
});

export default function PublicStatistics() {
  const [currentPublicHospital, setCurrentPublicHospital] = useState<number>(0);

  return (
    <>
      <Container>
        <LightPurpleContainer style={{ marginTop: 0 }}>
          <Container>
            <Typography variant="h4">Pregled statističkih podataka</Typography>
            <PublicHospitalsContext.Provider
              value={{
                currentPublicHospital: currentPublicHospital,
                setCurrentPublicHospital: setCurrentPublicHospital,
              }}
            >
              <HospitalDropdownMenu isPublic={true} />
              {currentPublicHospital ? (
                <div>
                  <HospitalInfoPanel isPublic={true} />
                  <StatisticsTable isPublic={true} />
                </div>
              ) : (
                <NoData>
                  Nema podataka.
                  <br /> Molimo vas da odaberete zdravstvenu ustanovu iz
                  <br /> padajućeg izbornika na vrhu stranice.
                </NoData>
              )}
            </PublicHospitalsContext.Provider>
          </Container>
        </LightPurpleContainer>
      </Container>
    </>
  );
}
